import React from 'react';
import connectStatic from 'app/utils/connectStatic';
import Page from 'app/containers/parts/Page';
import StaticContent from 'app/components/static/StaticContent';
import t from 'app/utils/translate';

const PrivacyPolicyContent = connectStatic({
  index: 'privacy',
  layout: 'complex',
  title: t('Privacy Policy'),
})(StaticContent);

function PrivacyPolicy() {
  return (
    <Page>
      <PrivacyPolicyContent />
    </Page>
  );
}

export default PrivacyPolicy;
